// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__33poo","question":"Question_question__3SAoR","description":"Question_description__qOLOB"};